import { createSlice } from '@reduxjs/toolkit'

export const stepTwoSlicer = createSlice({
  name: 'stepTwo',
  initialState: {
    arr: {}
  },
  reducers: {

    add: (state, action) => {
          state.arr = action.payload; 
    },
  },
})

// Action creators are generated for each case reducer function
export const { add } = stepTwoSlicer.actions

export default stepTwoSlicer.reducer